import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Edit = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 0.792847L15.2071 4.49995L5.70711 14H2V10.2928L11.5 0.792847ZM9.70711 3.99995L12 6.29285L13.7929 4.49995L11.5 2.20706L9.70711 3.99995ZM11.2929 6.99995L9 4.70706L3 10.7071V13H5.29289L11.2929 6.99995Z"
      />
    </svg>
  ),
)
Edit.displayName = 'Edit'

export default Edit
